if (!customElements.get('collapsible-content')) {
  class CollapsibleContent extends HTMLElement {
    constructor() {
      super();
      this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    connectedCallback() {
      this.toggles = this.querySelectorAll('.collapsible-content__toggle');

      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', this.handleToggleClick);
        if (toggle.parentElement?.classList.contains('active')) {
          const answer = toggle.nextElementSibling;
          if (answer) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
            toggle.setAttribute('aria-expanded', 'true');
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.toggles) {
        this.toggles.forEach((toggle) => {
          toggle.removeEventListener('click', this.handleToggleClick);
        });
      }
    }

    handleToggleClick(event) {
      const toggle = event.currentTarget;
      const parent = toggle.parentElement;
      const answer = toggle.nextElementSibling;
      if (!parent || !answer) return;

      const isActive = parent.classList.contains('active');

      // Accordion mode: close all other open items first
      this.resetActiveItems(parent);

      parent.classList.toggle('active', !isActive);
      toggle.setAttribute('aria-expanded', String(!isActive));
      answer.style.maxHeight = !isActive ? answer.scrollHeight + 'px' : '0px';
    }

    resetActiveItems(currentParent) {
      const activeItems = this.querySelectorAll('.collapsible-content__item.active');
      activeItems.forEach((item) => {
        if (item !== currentParent) {
          item.classList.remove('active');
          const activeToggle = item.querySelector('.collapsible-content__toggle');
          const activeAnswer = item.querySelector('.collapsible-content__answer');
          if (activeToggle) activeToggle.setAttribute('aria-expanded', 'false');
          if (activeAnswer) activeAnswer.style.maxHeight = '0px';
        }
      });
    }
  }

  customElements.define('collapsible-content', CollapsibleContent);
}
